import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ActiveTimerV2State {
  taskId: string | null;
  setTaskId: (taskId: string | null) => void;
}

// В v2 нет ручки «мой активный таймер»: id задачи запоминаем при старте, а идёт ли таймер — спрашиваем у бэка.
export const useActiveTimerV2Store = create<ActiveTimerV2State>()(
  persist(
    (set) => ({
      taskId: null,
      setTaskId: (taskId) => set({ taskId }),
    }),
    { name: 'task-timer-v2-active' }
  )
);
